module.exports = __webpack_public_path__ + "img/021-boy-8.ea3593a2.svg";